import * as React from "react";
const defaultRoutingContextValue = [
  { goTo: () => null },
  {
    component: void 0,
    queryParams: {},
    currentRoute: "",
    basePath: "",
    signInMyAccountUrl: void 0,
    routerId: void 0
  }
];
const RoutingContext = React.createContext(
  defaultRoutingContextValue
);
const useRoutingContext = () => {
  const context = React.useContext(RoutingContext);
  if (!context) {
    throw new Error("useRoutingContext must be used within a RoutingContextProvider");
  }
  return context;
};
export {
  RoutingContext,
  defaultRoutingContextValue,
  useRoutingContext
};
//# sourceMappingURL=context.js.map
